import { useEffect, useState } from 'react';

const useAnimated = (fixed, delay) => {
  const [animated, setAnimated] = useState(false);

  useEffect(() => {
    let timeoutId;

    if (fixed) {
      timeoutId = setTimeout(() => {
        setAnimated(true);
      }, delay);
    } else {
      clearTimeout(timeoutId);
      setAnimated(false);
    }

    return () => clearTimeout(timeoutId);
  }, [fixed, delay]);

  return animated;
};

export default useAnimated;
